import type { Money } from '@alpha/api-client';

const usd = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const lds = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 4,
});

/** Money arrives as a decimal string; parse only at the display boundary. */
export function formatUsd(value: Money | null | undefined): string {
  if (value == null || value === '') return '$0.00';
  const n = Number(value);
  return Number.isFinite(n) ? usd.format(n) : '$0.00';
}

export function formatLds(value: Money | null | undefined): string {
  if (value == null || value === '') return '0 LDS';
  const n = Number(value);
  return Number.isFinite(n) ? `${lds.format(n)} LDS` : '0 LDS';
}

export function formatNumber(value: number | null | undefined): string {
  return (value ?? 0).toLocaleString('en-US');
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return '—';
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return `${formatDate(value)} ${d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}`;
}

export type ChipTone = 'success' | 'danger' | 'warning' | 'info' | 'gold';

export function statusTone(status: string): ChipTone {
  switch (status) {
    case 'approved':
    case 'active':
    case 'paid':
    case 'success':
    case 'closed':
      return 'success';
    case 'rejected':
    case 'blocked':
    case 'failed':
    case 'forfeited':
      return 'danger';
    case 'pending':
    case 'processing':
    case 'running':
    case 'paused':
      return 'warning';
    case 'answered':
    case 'open':
      return 'info';
    default:
      return 'gold';
  }
}
